<template>
  <div>
    <b-tabs v-model="activeTab" type="is-boxed" @change="deleteTab()">
        <b-tab-item label="Create New User">
          <div class="columns">
              <div class="column"></div>
              <div class="column is-three-quarters">
                <p>Please fill out the form to create a new user.</p>

                <section style="margin-top: 10px;">
                    <b-field label="First Name" >
                        <b-input placeholder="First Name" type="text" v-model="user.first_name"></b-input>
                    </b-field>

                    <b-field label="Last Name" >
                        <b-input placeholder="Last Name" type="text" v-model="user.last_name"></b-input>
                    </b-field>

                    <b-field label="Email" >
                        <b-input placeholder="Email" type="email" v-model="user.email"></b-input>
                    </b-field>

                    <b-field label="Password">
                        <b-input type="password" v-model="user.password"
                            value=""
                            password-reveal>
                        </b-input>
                    </b-field>

                    <b-field label="Photo URL">
                        <b-input placeholder="photo_url" type="url" v-model="user.photo_url"></b-input>
                    </b-field>

                    <b-field label="Google Sheet URL">
                        <b-input placeholder="Google Spread Sheet URL" type="url" v-model="user.sheet_url"></b-input>
                    </b-field>

                    <div class="has-text-centered">
                      <button type="button" class="button is-primary is-medium " name="button" @click="signUp()">Submit</button>
                    </div>
                </section>
              </div>
              <div class="column"></div>
          </div>

        </b-tab-item>

        <b-tab-item label="Update User">

        </b-tab-item>

        <b-tab-item label="Detele User">
          <delete-user-tab v-if="activeTab === 2"></delete-user-tab>
        </b-tab-item>
    </b-tabs>
  </div>
</template>
<script>
import moment from 'moment';
import DeleteUserTab from './manage_users/DeleteUserTab.vue'
import { ToastProgrammatic as Toast } from 'buefy'
export default {
  name: "",
  data: () => ({
    user: {},
    activeTab: 0
  }),
  components: {
    'delete-user-tab'       : DeleteUserTab
  },
  methods: {
    deleteTab() {
      console.log(this.activeTab);
      console.log('delete Tab');
    },
    signUp() {
      //Assign default photo url if not provided
      if (!this.user.photo_url) {
        this.user.photo_url = 'https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_1280.png'
      }

      if (!this.user.sheet_url) {
          this.user.sheet_url = ''
      }

      let vm = this;
      firebase.auth().createUserWithEmailAndPassword(this.user.email, this.user.password).then(function(user) {
        vm.notify(`You have signed in as ` + vm.user.email, 'is-success', 3000);

        //update user profile
        user.updateProfile({
          displayName: _.capitalize(vm.user.first_name) + " " + _.capitalize(vm.user.last_name),
          photoURL: vm.user.photo_url
        }).then(function() {

          let updates = {};
          updates['/users/' + user.uid ] = {
            'displayName': _.capitalize(vm.user.first_name) + " " + _.capitalize(vm.user.last_name),
            'email': vm.user.email,
            'firstName': _.capitalize(vm.user.first_name),
            'lastName': _.capitalize(vm.user.last_name),
            'photoURL': vm.user.photo_url,
            'sheetURL': vm.user.sheet_url,
            'createdAt': moment(firebase.database.ServerValue.TIMESTAMP).toISOString(),
            'timeStamp': firebase.database.ServerValue.TIMESTAMP,
            'roles': {
              admin: false,
              user: true
            }
          };

          firebase.database().ref().update(updates, function() {
            for (var i = 5; i >= 1; i++) {
              vm.notify(`Signing out in ` + i + ` seconds`, 'is-dark', 1000);
            }
            setTimeout(function(){ vm.signOut(); }, 8000);
          });

        }).catch(function(error) {
          console.log(error);
          vm.notify(error.message, 'is-danger');
        });

        //sign out
      }).catch(function(error) {
        vm.notify(error.message, 'is-danger');
      });
    },
    signOut() {
      firebase.auth().signOut().then(function() {
        // Sign-out successful, redirect back to home page
        window.location.href="/";
      }).catch(function(error) {
        console.log(eror)
      });
    },
    notify(msg, type, time) {
      Toast.open({
          duration: time,
          message: msg,
          type: type
      });
    }
  },
  mounted() {
    let database = firebase.database();
  }
}
</script>
<style lang="scss" scoped>
.tabs li.is-active a {
  color: #7957d5 !important;
}
</style>



// WEBPACK FOOTER //
// ManageUsers.vue?82ba111a